module.exports = __webpack_public_path__ + "static/media/39_Projects_Cell.9a998797.JPG";